module.exports = __webpack_public_path__ + "images/Video-Lane.ff334d6e366121d0a529c071c8af2ea7.svg";